import { useFeatureFlagEnabled } from "posthog-js/react";

import { useAccount } from "@/hooks";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;

export function useCanSeeDebugMenu() {
  const { account } = useAccount();
  const email = account?.email || "";

  const canSeeDebugMenu = useFeatureFlagEnabled(
    "canSeeDebugMenu",
  );

  return (
    canSeeDebugMenu ||
    (["dev", "dojo"].includes(REACT_ENV) && email.endsWith("@mylot.ai")) ||
    (["dev", "dojo"].includes(REACT_ENV) && email.endsWith("@localhost.com"))
  );
}
